module.exports = __webpack_public_path__ + "static/media/cloneterest-screenshot-3.f48a3823.jpg";